import { NavLink } from 'react-router-dom';
import { Inbox, Target, Crosshair, Users, Globe, Flame } from 'lucide-react';

const NAV_ITEMS = [
    { to: '/inbox', icon: Inbox, label: 'Inbox' },
    { to: '/campaigns', icon: Target, label: 'Campaigns' },
    { to: '/sniper', icon: Crosshair, label: 'Sniper' },
    { to: '/contacts', icon: Users, label: 'Contacts' },
    { to: '/domains', icon: Globe, label: 'Domains' },
    { to: '/warmup', icon: Flame, label: 'Warmup' },
];

interface SidebarProps {
    unreadCount: number;
}

export function Sidebar({ unreadCount }: SidebarProps) {
    return (
        <aside className="app-sidebar">
            <div className="sidebar-brand">
                <h1 style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        width: 28, height: 28, borderRadius: 8,
                        background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
                    }}>
                        <Flame size={16} color="#fff" />
                    </span>
                    Acquisition
                </h1>
                <p>Client discovery &amp; outreach</p>
            </div>

            <nav className="sidebar-nav">
                {NAV_ITEMS.map((item) => {
                    const Icon = item.icon;
                    return (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                        >
                            <span className="nav-icon" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Icon size={18} />
                            </span>
                            {item.label}
                            {item.to === '/inbox' && unreadCount > 0 && (
                                <span className="nav-badge">{unreadCount}</span>
                            )}
                        </NavLink>
                    );
                })}
            </nav>

            <div style={{ padding: '12px 16px', borderTop: '1px solid var(--border-default)' }}>
                <div style={{ fontSize: 11, color: 'var(--text-dim)' }}>
                    v1.0 · Acquisition Engine
                </div>
            </div>
        </aside>
    );
}
